<template>
  <div class="input-insertion">
    <span v-for="(item, index) in inputList" :key="index" class="main">
      <span style="white-space:nowrap;">{{ item.label }}</span>
      <sky-input
        class="item-input"
        v-if="showinput(item, index)"
        :value="item.value"
        size="mini"
        @change="e => change(e, index)"
      ></sky-input>
    </span>
  </div>
</template>

<script>
import skyInput from '@/components/iglobalwin/formComponents/sky-input';
export default {
  props: ['scope', 'tableData'],
  data() {
    return {
      selfData: false
    };
  },
  computed: {
    inputList() {
      let { scope, tableData } = this;
      if (!(scope && tableData)) return [];
      if (!scope.row[tableData.bind]) return [];
      let data = scope.row[tableData.bind];
      let array = data.split('%N%');
      let ruleVals = scope.row[tableData.default] || [];
      let newArray = [];
      array.forEach((item, index) => {
        newArray.push({
          label: item,
          value: ruleVals[index] || ''
        });
      });
      return newArray;
    }
  },
  methods: {
    showinput(item, index) {
      if (this.inputList.length == 1) return false;
      if (index == this.inputList.length - 1) return false;
      return true;
    },
    change(val, index) {
      this.tableData.change(val, index, this.scope.row);
    }
  },
  components: { skyInput }
};
</script>

<style>
.input-insertion .item-input .el-input__inner {
  height: 22px;
  line-height: 22px;
  padding: 0 5px;
  text-align: center;
}
</style>

<style lang="scss" scoped>
.input-insertion {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: nowrap;
  overflow-x: auto;
  padding: 3px 0;
}

// 改变滚动条样式
.input-insertion::-webkit-scrollbar {
  height: 4px;
}
.input-insertion::-webkit-scrollbar-thumb {
  background-color: #d8d8d8;
  border-radius: 2px;
}
.input-insertion::-webkit-scrollbar-track {
  background-color: #fff;
  border-radius: 2px;
}
.main {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  // flex-wrap: nowrap;
  .item-input {
    width: 40px;
    height: 22px;
    margin: 0 5px;
  }
}
</style>
